import { BASE_URL } from "./constant";

export default class Route {
    // static baseURL = 'https://apidev.8well.com'
    // static baseURL =
    //   process.env.NODE_ENV === "development"
    //     ? "http://localhost:5000"
    //     : "https://apidev.8well.com";

    // BASE_URL
    static baseURL = BASE_URL;
    // static baseURL = "http://localhost:8000/api";
    // static loginbaseURL = "http://192.168.1.2:8000";
    // static loginbaseURL = "http://localhost:8000";
    // static baseURL = "https://13.126.251.220:4000/api";



    // --------------AUTH--------------
    // login
    // ===================================
    static userlogin = `${this.loginbaseURL}/v1/oauth/token`;

    // get the login user details from its login token 
    // ===================================
    // static getLoginUserDetails = `${this.loginbaseURL}/v1/oauth/token`;
    static getLoginUserDetails = `${this.baseURL}/login`;

    // email verification
    // ===================================
    static verifyEmail = `${this.baseURL}/verify-email`;
    static resendVerificationEmail = `${this.baseURL}/email/resend`;

    // register (public)
    // ===================================
    static registerUser = `${this.baseURL}/register`;

    // forgot / reset password (public)
    // ===================================
    static forgotPassword = `${this.baseURL}/forgot-password`;
    static resetPassword = `${this.baseURL}/reset-password`;

    // logout
    // ===================================
    static logout = `${this.baseURL}/logout`;


    // --------------PLANS--------------
    // list of plans 
    // ===================================
    static listOfPlans = `${this.baseURL}/plans/list`;

    // add plan 
    // ===================================
    static addPlan = `${this.baseURL}/plans/add`;

    // edit plan 
    // ===================================
    static editPlan = `${this.baseURL}/plans`;

    // update plan 
    // ===================================
    static updatePlan = `${this.baseURL}/plans`;



    // ===================================
    // USER MODULE APIS 
    // ===================================
    // list of Users 
    // ===================================
    static listOfUser = `${this.baseURL}/users/list`;

    // add Users
    // ===================================
    static addUser = `${this.baseURL}/users/add`;

    // edit Users 
    // ===================================
    static editUser = `${this.baseURL}/users`;

    // update Users 
    // ===================================
    static updateUser = `${this.baseURL}/users`;

    // delete Users (summary first, for the confirmation)
    // ===================================
    static deleteUser = `${this.baseURL}/users`;


    // ===================================
    // RECIPE MASTER MODULE APIS 
    // ===================================
    // --------------Recipe Category--------------
    // list of categories 
    // ===================================
    static listOfRecipeCategories = `${this.baseURL}/recipe_category/list`;

    // add category
    // ===================================
    static addRecipeCategory = `${this.baseURL}/recipe_category/add`;

    // edit category 
    // ===================================
    static editRecipeCategory = `${this.baseURL}/recipe_category`;

    // update category 
    // ===================================
    static updateRecipeCategory = `${this.baseURL}/recipe_category`;


    // --------------Recipe Types--------------
    // list of recipe types 
    // ===================================
    static listOfRecipeTypes = `${this.baseURL}/recipe_type/list`;

    // add recipe type 
    // ===================================
    static addRecipeType = `${this.baseURL}/recipe_type/add`;

    // edit recipe type 
    // ===================================
    static editRecipeType = `${this.baseURL}/recipe_type`;

    // update recipe type 
    // ===================================
    static updateRecipeType = `${this.baseURL}/recipe_type`;


    // --------------Recipe Pheno Types--------------
    // list of Pheno Types 
    // ===================================
    static listOfRecipeTypes = `${this.baseURL}/recipe_type/list`;

    // add Pheno Types 
    // ===================================
    static addRecipeType = `${this.baseURL}/recipe_type/add`;

    // edit Pheno Types 
    // ===================================
    static editRecipeType = `${this.baseURL}/recipe_type`;

    // update Pheno Types 
    // ===================================
    static updateRecipeType = `${this.baseURL}/recipe_type`;

    // --------------Recipe Meal Time--------------
    // list of Meal Time 
    // ===================================
    static listOfMealTime = `${this.baseURL}/meal_time/list`;

    // add Meal Time
    // ===================================
    static addRecipelistOfMealTime = `${this.baseURL}/meal_time/add`;

    // edit Meal Time 
    // ===================================
    static editRecipelistOfMealTime = `${this.baseURL}/meal_time`;

    // update Meal Time 
    // ===================================
    static updateRecipelistOfMealTime = `${this.baseURL}/meal_time`;


    // --------------Recipe Meal Time--------------
    // list of Meal Time 
    // ===================================
    static listOfIngredientForm = `${this.baseURL}/ingredients_form/list`;

    // add Meal Time
    // ===================================
    static addIngredientForm = `${this.baseURL}/ingredients_form/add`;

    // edit Meal Time 
    // ===================================
    static editIngredientForm = `${this.baseURL}/ingredients_form`;

    // update Meal Time 
    // ===================================
    static updateIngredientForm = `${this.baseURL}/ingredients_form`;


    // --------------Ingredient Unit--------------
    // list of Ingredient Unit 
    // ===================================
    static listOfIngredientUnit = `${this.baseURL}/ingredients_unit/list`;

    // add Ingredient Unit
    // ===================================
    static addIngredientUnit = `${this.baseURL}/ingredients_unit/add`;

    // edit Ingredient Unit 
    // ===================================
    static editIngredientUnit = `${this.baseURL}/ingredients_unit`;

    // update Ingredient Unit 
    // ===================================
    static updateIngredientUnit = `${this.baseURL}/ingredients_unit`;


    // --------------Recipe Tag List--------------
    // list of Ingredient Unit 
    // ===================================
    static listOfRecipeTag = `${this.baseURL}/recipe_tag/list`;

    // add Ingredient Unit
    // ===================================
    static addRecipeTag = `${this.baseURL}/recipe_tag/add`;

    // edit Ingredient Unit 
    // ===================================
    static editRecipeTag = `${this.baseURL}/recipe_tag`;

    // update Ingredient Unit 
    // ===================================
    static updateRecipeTag = `${this.baseURL}/recipe_tag`;


    // --------------Macros Micros List--------------
    // list of Macros Micros 
    // ===================================
    static listOfMacrosMicros = `${this.baseURL}/macros_micros/list`;

    // add Macros Micros
    // ===================================
    static addMacrosMicros = `${this.baseURL}/macros_micros/add`;

    // edit Macros Micros 
    // ===================================
    static editMacrosMicros = `${this.baseURL}/macros_micros`;

    // update Macros Micros 
    // ===================================
    static updateMacrosMicros = `${this.baseURL}/macros_micros`;

    // ===================================
    // PATIENT MASTER MODULE APIS 
    // ===================================
    // --------------Menstrual History--------------
    // list of menstrual_history 
    // ===================================
    static listOfMenstrualHistory = `${this.baseURL}/menstrual_history/list`;

    // add menstrual_history
    // ===================================
    static addMenstrualHistory = `${this.baseURL}/menstrual_history/add`;

    // edit menstrual_history 
    // ===================================
    static editMenstrualHistory = `${this.baseURL}/menstrual_history`;

    // update menstrual_history 
    // ===================================
    static updateMenstrualHistory = `${this.baseURL}/menstrual_history`;

    // delete menstrual_history 
    // ===================================
    static deleteMenstrualHistory = `${this.baseURL}/menstrual_history`;


    // --------------Diseases--------------
    // list of Diseases 
    // ===================================
    static listOfDiseases = `${this.baseURL}/diseases/list`;

    // add Diseases
    // ===================================
    static addDiseases = `${this.baseURL}/diseases/add`;

    // edit Diseases 
    // ===================================
    static editDiseases = `${this.baseURL}/diseases`;

    // update Diseases 
    // ===================================
    static updateDiseases = `${this.baseURL}/diseases`;

    // --------------Bp Measurement--------------
    // list of Bp Measurement 
    // ===================================
    static listOfBpMeasurement = `${this.baseURL}/bp_Measurement/list`;

    // add Bp Measurement
    // ===================================
    static addBpMeasurement = `${this.baseURL}/bp_Measurement/add`;

    // edit Bp Measurement 
    // ===================================
    static editBpMeasurement = `${this.baseURL}/bp_Measurement`;

    // update Bp Measurement 
    // ===================================
    static updateBpMeasurement = `${this.baseURL}/bp_Measurement`;


    // --------------Routine Diet--------------
    // list of Bp Measurement 
    // ===================================
    static listOfRoutineDiet = `${this.baseURL}/routine_diet/list`;

    // add Bp Measurement
    // ===================================
    static addRoutineDiet = `${this.baseURL}/routine_diet/add`;

    // edit Bp Measurement 
    // ===================================
    static editRoutineDiet = `${this.baseURL}/routine_diet`;

    // update Bp Measurement 
    // ===================================
    static updateRoutineDiet = `${this.baseURL}/routine_diet`;

    // --------------Reason Of Weight Loss--------------
    // list of WeightLoss Reason 
    // ===================================
    static listOfWeightLoss = `${this.baseURL}/reason_of_weight_loss/list`;

    // add WeightLoss Reason
    // ===================================
    static addWeightLoss = `${this.baseURL}/reason_of_weight_loss/add`;

    // edit WeightLoss Reason 
    // ===================================
    static editWeightLoss = `${this.baseURL}/reason_of_weight_loss`;

    // update WeightLoss Reason 
    // ===================================
    static updateWeightLoss = `${this.baseURL}/reason_of_weight_loss`;


    // --------------DietTime--------------
    // list of Diet Time 
    // ===================================
    static listOfDietTime = `${this.baseURL}/diet_time/list`;

    // add Diet Time
    // ===================================
    static addDietTime = `${this.baseURL}/diet_time/add`;

    // edit Diet Time 
    // ===================================
    static editDietTime = `${this.baseURL}/diet_time`;

    // update Diet Time 
    // ===================================
    static updateDietTime = `${this.baseURL}/diet_time`;


    // --------------Diet Types--------------
    // list of Diet Time 
    // ===================================
    static listOfDietTypes = `${this.baseURL}/diet_types/list`;

    // add Diet Time
    // ===================================
    static addDietTypes = `${this.baseURL}/diet_types/add`;

    // edit Diet Time 
    // ===================================
    static editDietTypes = `${this.baseURL}/diet_types`;

    // update Diet Time 
    // ===================================
    static updateDietTypes = `${this.baseURL}/diet_types`;


    // --------------Measurements Unit--------------
    // list of Diet Time 
    // ===================================
    static listOfMeasurementsUnit = `${this.baseURL}/measurements_unit/list`;

    // add Diet Time
    // ===================================
    static addMeasurementsUnit = `${this.baseURL}/measurements_unit/add`;

    // edit Diet Time 
    // ===================================
    static editMeasurementsUnit = `${this.baseURL}/measurements_unit`;

    // update Diet Time 
    // ===================================
    static updateMeasurementsUnit = `${this.baseURL}/measurements_unit`;


    // --------------QuestionDomain--------------
    // list of Question Domain
    // ===================================
    static listOfQuestionDomain = `${this.baseURL}/question_domain/list`;

    // add Question Domain
    // ===================================
    static addQuestionDomain = `${this.baseURL}/question_domain/add`;

    // edit Question Domain
    // ===================================
    static editQuestionDomain = `${this.baseURL}/question_domain`;

    // update Question Domain
    // ===================================
    static updateQuestionDomain = `${this.baseURL}/question_domain`;


    // --------------Herb Management--------------
    // list of Question Domain
    // ===================================
    static listOfHerbManagement = `${this.baseURL}/herb/list`;

    // add Question Domain
    // ===================================
    static addHerbManagement = `${this.baseURL}/herb/add`;

    // edit Question Domain
    // ===================================
    static editHerbManagement = `${this.baseURL}/herb`;

    // update Question Domain
    // ===================================
    static updateHerbManagement = `${this.baseURL}/herb`;

    // --------------Phenotype QuestionDomain--------------
    // list of Question Domain
    // ===================================
    static listOfPhenotypeQuestion = `${this.baseURL}/phenotype_question/list`;

    // add Question Domain
    // ===================================
    static addPhenotypeQuestion = `${this.baseURL}/phenotype_question/add`;

    // edit Question Domain
    // ===================================
    static editPhenotypeQuestion = `${this.baseURL}/phenotype_question`;

    // update Question Domain
    // ===================================
    static updatePhenotypeQuestion = `${this.baseURL}/phenotype_question`;


    // --------------Measurements Types--------------
    // list of Measurements Types
    // ===================================
    static listOfMeasurementTypes = `${this.baseURL}/measurements_type/list`;

    // add Measurements Types
    // ===================================
    static addMeasurementType = `${this.baseURL}/measurements_type/add`;

    // edit Measurements Types
    // ===================================
    static editMeasurementType = `${this.baseURL}/measurements_type`;

    // update Measurements Types
    // ===================================
    static updateMeasurementType = `${this.baseURL}/measurements_type`;


    // --------------Focus Health Areas--------------
    // list of Focus Health Areas
    // ===================================
    static listOfFocusHealthArea = `${this.baseURL}/health_focus_area/list`;

    // add Focus Health Areas
    // ===================================
    static addFocusHealthArea = `${this.baseURL}/health_focus_area/add`;

    // edit Focus Health Areas
    // ===================================
    static editFocusHealthArea = `${this.baseURL}/health_focus_area`;

    // update Focus Health Areas
    // ===================================
    static updateFocusHealthArea = `${this.baseURL}/health_focus_area`;

    // --------------Country--------------
    // list of Country
    // ===================================
    static listOfCountry = `${this.baseURL}/country/list`;

    // add Country
    // ===================================
    static addCountry = `${this.baseURL}/country/add`;

    // edit Country
    // ===================================
    static editCountry = `${this.baseURL}/country`;

    // update Country
    // ===================================
    static updateCountry = `${this.baseURL}/country`;

    // --------------State--------------
    // list of State
    // ===================================
    static listOfState = `${this.baseURL}/state/list`;

    // add State
    // ===================================
    static addState = `${this.baseURL}/state/add`;

    // edit State
    // ===================================
    static editState = `${this.baseURL}/state`;

    // update State
    // ===================================
    static updateState = `${this.baseURL}/state`;

    // --------------City--------------
    // list of City
    // ===================================
    static listOfCity = `${this.baseURL}/city/list`;

    // add City
    // ===================================
    static addCity = `${this.baseURL}/city/add`;

    // edit City
    // ===================================
    static editCity = `${this.baseURL}/city`;

    // update City
    // ===================================
    static updateCity = `${this.baseURL}/city`;


    // ========================================
    // User Profile
    // ------------------------
    static getUserProfileDetails = `${this.baseURL}/users`;

    // ========================================
    // Complaints
    // ========================================

    // list of Complaints
    // ===================================
    static listOfComplaints = `${this.baseURL}/complaints/list`;

    // add complaintss
    static addComplaints = `${this.baseURL}/complaints/add`;


    // ========================================
    // Program
    // ========================================

    // list of Program
    // ===================================
    static listOfProgram = `${this.baseURL}/program/list`;

    // add Program
    // ===================================
    static addProgram = `${this.baseURL}/program/add`;

    // edit Program
    // ===================================
    static editProgram = `${this.baseURL}/program`;

    // update Program
    // ===================================
    static updateProgram = `${this.baseURL}/program`;


    // ========================================
    // Ingredients Api Routes
    // ========================================

    // list of Ingredients
    // ===================================
    static listOfIngredients = `${this.baseURL}/ingredients/list`;

    // add Ingredients
    // ===================================
    static addIngredients = `${this.baseURL}/ingredients/add`;

    // edit Ingredients
    // ===================================
    static editIngredients = `${this.baseURL}/ingredients`;

    // update Ingredients
    // ===================================
    static updateIngredients = `${this.baseURL}/ingredients`;


    // ===================================
    // CLIENT DETAIL PAGES APIS 
    // ===================================

    // PhenoType Analysis Apis
    // ========================================
    // list of PhenoType Analysis Data
    // ===================================
    static listOfPhenoTypeAnalysis = `${this.baseURL}/patient/phenotype_analysis/list`;

    // add PhenoType Analysis Data
    // ===================================
    static addPhenoTypeAnalysis = `${this.baseURL}/patient/phenotype_analysis`;


    // Measurement Record Of Patient
    // ========================================
    // list of Measurement Record Of Patient
    // ===================================
    static listOfPatientMeasurementRecord = `${this.baseURL}/patient/measurement/list`;

    // add Measurement Record Of Patient
    // ===================================
    static addPatientMeasurementRecord = `${this.baseURL}/patient/measurement/add`;


    // ========================================
    // Client (Patient) Routes
    // ========================================

    // list of Client
    // ===================================
    static listOfClient = `${this.baseURL}/patient/list`;

    // plans and payments (the doctor's own)
    // ===================================
    static billing = `${this.baseURL}/billing`;

    // appointments
    // ===================================
    static appointments = `${this.baseURL}/appointments`;

    // add Client
    // ===================================
    static addClient = `${this.baseURL}/patient/add`;

    // check a client's email / mobile against the doctor's other clients
    static clientDuplicateCheck = `${this.baseURL}/patient/duplicate-check`;

    // edit Client
    // ===================================
    static editClient = `${this.baseURL}/patient`;

    // update Client
    // ===================================
    static updateClient = `${this.baseURL}/patient`;

    // ========================================
    // Client Detail-> Medical Data
    // ========================================

    // list of Client Medical Data
    // ===================================
    static listOfMedicalData = `${this.baseURL}/patient/medical_history/list`;

    // add Client Medical Data
    // ===================================
    static addMedicalData = `${this.baseURL}/patient/medical_history/add`;

    // edit Client Medical Data
    // ===================================
    static editMedicalData = `${this.baseURL}/patient/medical_history`;

    // update Client Medical Data
    // ===================================
    static updateMedicalData = `${this.baseURL}/patient/medical_history`;


    // ========================================
    // Client Detail-> Routine Diet
    // ========================================

    // list of Client Patient Routine Diet
    // ===================================
    static listOfPatientRoutineDiet = `${this.baseURL}/patient-routine-diets/list`;

    // add Client Patient Routine Diet
    // ===================================
    static addPatientRoutineDiet = `${this.baseURL}/patient-routine-diets`;

    // edit Client Patient Routine Diet
    // ===================================
    static editPatientRoutineDiet = `${this.baseURL}/patient-routine-diets`;

    // update Client Patient Routine Diet
    // ===================================
    static updatePatientRoutineDiet = `${this.baseURL}/patient-routine-diets`;

    // ========================================
    // Client Detail -> Tag
    // ========================================
    // list of Tag
    // ===================================
    static listOfTag = `${this.baseURL}/patient/tag/list`;

    // add Tag
    // ===================================
    static addTag = `${this.baseURL}/patient/tag/add`;

    // // edit Tag
    // // ===================================
    // static editTag = `${this.baseURL}/patient/tag`;

    // // update Tag
    // // ===================================
    // static updateTag = `${this.baseURL}/tag`;

    // delete Tag
    // ===================================
    static deleteTag = `${this.baseURL}/patient/tag/destroy`;

    // ========================================
    // Client Detail -> Assign Herb 
    // ========================================
    // list of Assign Herb
    // ===================================
    static listOfAssignHerb = `${this.baseURL}/patient/assign_herb/list`;

    // add Assign Herb
    // ===================================
    static addAssignHerb = `${this.baseURL}/patient/assign_herb/add`;

    // update Assign Herb
    // ===================================
    static updateAssignHerb = `${this.baseURL}/patient/assign_herb`;

    // ========================================
    // Client Detail -> Assign Diet
    // ========================================
    // list of Assign Diet
    // ===================================
    static listOfAssignDiet = `${this.baseURL}/patient/assign_diet/list`;
    // week of assigned diets, unsent days, send (email + PDF), PDF
    static assignDiet = `${this.baseURL}/patient/assign_diet`;

    // add Assign Diet
    // ===================================
    static addAssignDiet = `${this.baseURL}/patient/assign_diet/add`;

    // edit note
    // ===================================
    static editAssignDiet = `${this.baseURL}/patient/assign_diet`;

    // update Assign Diet
    // ===================================
    static updateAssignDiet = `${this.baseURL}/patient/assign_diet`;

    // ========================================
    // Client Detail -> Assign Diet
    // ========================================
    // ingredient avoided by client Apis in Client Detail 
    // ===================================
    static avoidIngredientByClient = `${this.baseURL}/patient/avoid_ingredient`;

    // ========================================
    // Client Detail -> Assign Diet
    // ========================================
    // list of Assign Diet
    // ===================================
    static listOfRecipes = `${this.baseURL}/recipe/list`;
    static recipeNameAvailable = `${this.baseURL}/recipe/name-available`;

    // add Assign Diet
    // ===================================
    static addNewRecipe = `${this.baseURL}/recipe/add`;

    // edit note
    // ===================================
    static editRecipe = `${this.baseURL}/recipe`;

    // update Assign Diet
    // ===================================
    static updateRecipe = `${this.baseURL}/recipe`;

    // Recipe Image Upload 
    // ===================================
    static recipeImageUpload = `${this.baseURL}/recipe`;

}